<template>
  <div class="dragonHome">
    <div class="dragonNav">
      <div class="logo"></div>
      <div class="smHidden">
        <div class="navDiv myBar">
          <router-link class="nav" :class="{'navActive': activeIndex==0}" to="/chang_du/index">首页</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==1}" to="/chang_du/about">关于大赛</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==2}" to="/chang_du/guide">参赛指南</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==3}" to="/chang_du/award_setting">奖项设置</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==4}" to="/chang_du/evaluation">大赛评审</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==5}" to="/chang_du/sign_up?isShow=1">我要报名</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==7}" to="/chang_du/activities">相关资讯</router-link>
          <router-link class="nav" :class="{'navActive': activeIndex==9}" to="/chang_du/exemption">免责须知</router-link>  
        </div>
        <div class="signUp">
          <Button v-if="!gIsLogin()" class="signUpBtn" shape="circle" @click="toSignUp">我要报名</Button>
          <template v-else>
            <Dropdown>
              <div class="loginWrap">
                <img v-if="userInfo.avatar" class="userAvatar" :src="getImageUrl(userInfo.avatar, 'avatar')" alt="">
                <span class="userName">{{userInfo.trueName}}</span>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem><router-link class="downItemColor" to="/personal_info" target="_blank">完善信息</router-link></DropdownItem>
                <DropdownItem><span @click="logOut">退出登录</span></DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
        </div>
      </div>
      <div class="lgHidden">
        <div class="menuBoxWrap" @click="openNav"><div class="menuBox"></div></div>
        <div v-if="isNavOpen" class="navMask" @click="openNav"></div>
        <div class="smNavDiv" :class="{'navShow': isNavOpen}">
          <Button v-if="!gIsLogin()" class="signUpBtn smSignUpBtn" shape="circle" @click="toSignUp">我要报名</Button>
          <template v-else>
            <div>
              <img v-if="userInfo.avatar" class="userAvatar" :src="getImageUrl(userInfo.avatar, 'avatar')" alt="">
            </div>
            <p>{{userInfo.trueName}}</p>
          </template>
          <span class="nav" :class="{'navActive': activeIndex==0}" @click="closeNav('/chang_du/index')">首页</span>
          <span class="nav" :class="{'navActive': activeIndex==1}" @click="closeNav('/chang_du/about')" to="">关于大赛</span>
          <span class="nav" :class="{'navActive': activeIndex==2}" @click="closeNav('/chang_du/guide')">参赛指南</span>
          <span class="nav" :class="{'navActive': activeIndex==3}" @click="closeNav('/chang_du/award_setting')">奖项设置</span>
          <span class="nav" :class="{'navActive': activeIndex==4}" @click="closeNav('/chang_du/evaluation')">大赛评审</span>
          <span class="nav" :class="{'navActive': activeIndex==5}" @click="closeNav('/chang_du/sign_up?isShow=1')">我要报名</span>
          <span class="nav" :class="{'navActive': activeIndex==7}" @click="closeNav('/chang_du/activities')">相关资讯</span>
          <span class="nav" :class="{'navActive': activeIndex==9}" @click="closeNav('/chang_du/exemption')">免责须知</span>
          <template v-if="gIsLogin()">
            <router-link class="nav" to="/personal_info" target="_blank">完善信息</router-link>
            <span class="nav" @click="logOut">退出登录</span>
          </template>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <!-- copyright -->
    <div class="copyright center" :class="{'fixedCopyRight': activeIndex=='7'}">
      COPYRIGHT @ “津昌文化交流季”昌都文旅创新设计大赛组委会 保留一切权利<br class="lgHidden" style="display:none"/><span class="smHidden"> ｜ </span><span class="smHidden">京ICP备13011399号-4</span><span class="smHidden" style="display:none"> | 京公网安备 12345678909876号</span>
    </div>
    <!-- <BackTop><div class="backTop"></div></BackTop> -->
    <!-- 报名须知 -->
    <Modal v-model="isShow"
      title="昌都文旅创新设计大赛报名须知"
      :mask-closable="false"
      :footer-hide="true"
      class-name="notesModal"
      width="80">
      <SignUpNotes type="changdu" />
    </Modal>
  </div>
</template>

<script>
import SignUpNotes from "@/components/dragonStar/SignUpNotes.vue";
export default {
  components: {
    SignUpNotes
  },
  computed: {
    activeIndex() {
      let name = this.$route.name;
      if (name == "ChangDuIndex") {
        return 0;
      }
      if (name == "ChangDuAbout") {
        return 1;
      }
      if (name == "ChangDuGuide") {
        return 2;
      }
      if (name == "ChangDuAwardSetting") {
        return 3;
      }
      if (name == "ChangDuEvaluation") {
        return 4;
      }
      if (name == "ChangDuSignUp") {
        return 5;
      }
      if (name == "ChangDuActivities") {
        return 7;
      }
      if (name == "ChangDuExemption") {
        return 9;
      }
      return 0;
    }
  },
  data() {
    return {
      isShow: false,
      userInfo: {},
      isNavOpen: false
    };
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo;
    document.title = "昌都文旅创新设计大赛";
  },
  methods: {
    // 导航展开
    openNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    // 收起导航
    closeNav(path) {
      this.isNavOpen = false;
      this.$router.push(path);
    },
    // 退出登录
    logOut() {
      this.isNavOpen = false;
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");

      this.$route.name != "ChangDuIndex" &&
        this.$router.push("/chang_du/index");
    },
    // 去报名
    toSignUp() {
      this.isShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.dragonHome {
  padding-top: 100px;
  color: #353535;

  .dragonNav {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 100px;
    line-height: 100px;
    padding: 0 150px;
    text-align: center;
    z-index: 1000;
    background: #f7f7f7;
    .logo {
      position: absolute;
      left: 50px;
      top: 0;
      // width: 85px;
      // height: 100px;
      width: 282px;
      height: 100px;
      background: url(/img/changDu/logonew.png) no-repeat center 0px; 
      background-position: center 0px;
      background-size: cover;
      // background: url(/img/changDu/logo_1.png) no-repeat left center, url(/img/changDu/logo_2.png) no-repeat right center;
      // background-size: 42.5px, 42.5px;
    }
    .navDiv {
      overflow: auto;
      white-space: nowrap;

      .nav {
        display: inline-block;
        margin: 0 25px;
        color: #404040;
        font-weight: 600;
        position: relative;
      }
      .navActive {
        color: #d42a1b;
        cursor: default;
        pointer-events: none;
      }
      .navActive::after {
        content: "";
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 30px;
        height: 0;
        margin-left: -15px;
        border-top: 2px solid #d42a1b;
      }
    }

    .navDiv::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 2px;
    }
    .navDiv::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #777777;
    }
    .navDiv::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #eeeeee;
    }

    .menuBoxWrap {
      position: absolute;
      top: 41px;
      right: 20px;
      width: 18px;
      height: 18px;
    }
    .menuBox {
      width: 18px;
      height: 0;
      color: #404040;
      box-shadow: 0 8px 0 1px, 0 16px 0 1px, 0 0 0 1px;
    }
    .navMask {
      position: fixed;
      top: 100px;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }
    .smNavDiv {
      position: fixed;
      right: 0;
      top: 100px;
      bottom: 0;
      width: 0;
      background: #f7f7f7;
      line-height: 2em;
      transition: 100ms width;

      .nav {
        display: block;
        color: #404040;
        font-weight: 600;
      }
      .navActive {
        color: #d42a1b;
        cursor: default;
        pointer-events: none;
      }
      .smSignUpBtn {
        margin-bottom: 15px;
      }
      .userAvatar {
        width: 50px;
        height: 50px;
        border-radius: 30px;
        vertical-align: middle;
      }
      .userName {
        padding: 0 10px 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
    }
    .navShow {
      width: 150px;
    }

    .signUp {
      position: absolute;
      right: 50px;
      top: 0;
      max-width: 85px;

      .loginWrap {
        line-height: 1.8em;
        margin-top: 35px;
        cursor: pointer;

        &::after {
          position: absolute;
          right: -10px;
          top: 4px;
          content: "\f33d";
          font-family: Ionicons;
        }
      }

      .userAvatar {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        vertical-align: middle;
        margin-right: 5px;
      }
      .userName {
        display: inline-block;
        width: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      .downItemColor {
        color: #515a6e;
      }
    }
    .signUpBtn {
      background: linear-gradient(to right, #d42a1b, #c43a2e);
      border-color: #d42a1b;
      box-shadow: 0 2px 5px 2px rgba($color: #d42a1b, $alpha: 0.3);
    }
  }
  .copyright {
    padding: 10px 0;
    background: #3d3d3d;
    color: #ffffff;
    line-height: 1.8em;
  }
  .fixedCopyRight {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .lgHidden {
    display: none;
  }
}
@media (max-width: 992px) {
  .dragonHome {
    .dragonNav {
      padding: 0 0 0 110px;

      .navDiv .nav {
        margin: 0 10px;
      }

      .logo {
        left: 15px;
      }
      .signUp {
        right: 15px;
      }
    }
    .lgHidden {
      display: block;
    }
    .smHidden {
      display: none;
    }
  }
}
</style>